// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"982":"973e01f2bde66c0d","1987":"4d776aa2e84299ba","2888":"2b736e0cc4fa7e7a","7042":"5875e1c6507ee087"}[chunkId] + ".css";
};